import { Link } from 'react-router-dom'
import { ArrowUturnLeftIcon, CheckIcon } from '@heroicons/react/20/solid'
import moment from 'moment'

import { getTriageOption } from '../../../../klienci/Placowki/common/triageCategories'

const formatDateTime = value => {
	if (!value) return '-'
	return moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm') : '-'
}

export default function PlacowkiTableRow({
	item,
	isSelected,
	onSelectPlacowka,
	onMarkAsDone,
	onMarkAsUndone,
	processingId,
}) {
	const placowkaId = item?.placowkaId
	const isProcessing = processingId === item?._id
	const isDone = !!item?.doneDate
	const triageOption = getTriageOption(item?.triage)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 text-center w-12">
				<input
					type="checkbox"
					checked={isSelected}
					onChange={e => onSelectPlacowka(placowkaId, e.target.checked)}
					disabled={!placowkaId}
					className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 max-w-[360px]">
				<div className="truncate" title={item?.placowkaNazwa || '-'}>
					{item?.placowkaId ? (
						<Link
							to={`/klienci/placowki/details/${item.placowkaId}`}
							className="block truncate text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
							{item?.placowkaNazwa || '-'}
						</Link>
					) : (
						item?.placowkaNazwa || '-'
					)}
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{item?.miastoNazwa || '-'}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap max-w-[200px]">
				<div className="truncate" title={item?.gminaNazwa || '-'}>
					{item?.gminaNazwa || '-'}
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{item?.powiatNazwa || '-'}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{item?.wojewodztwoNazwa || '-'}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{item?.typNazwa || '-'}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{triageOption ? (
					<span
						className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${triageOption.colorClass}`}>
						{triageOption.label}
					</span>
				) : (
					'-'
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{isDone ? (
					<span className="inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700">
						Wykonane
					</span>
				) : (
					<span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
						Niewykonane
					</span>
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{formatDateTime(item?.doneDate)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{item?.doneByName || '-'}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
				<div className="inline-flex items-center gap-2">
					{!isDone ? (
						<button
							type="button"
							onClick={() => onMarkAsDone(item)}
							disabled={isProcessing}
							className="inline-flex items-center gap-1 rounded-md border border-green-100 bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700 hover:bg-green-100 disabled:cursor-not-allowed disabled:opacity-60">
							<CheckIcon className="h-4 w-4" />
							<span>Oznacz wykonane</span>
						</button>
					) : (
						<button
							type="button"
							onClick={() => onMarkAsUndone(item)}
							disabled={isProcessing}
							className="inline-flex items-center gap-1 rounded-md border border-amber-100 bg-amber-50 px-3 py-1.5 text-sm font-medium text-amber-700 hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-60">
							<ArrowUturnLeftIcon className="h-4 w-4" />
							<span>Oznacz niewykonane</span>
						</button>
					)}
				</div>
			</td>
		</tr>
	)
}
